// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__gZ04W","row":"ProcedureTreatmentSummary_row__2BCbh"};